<template>
  <div>
    <!--  标签-->
    <div class="scene">
      <div class="sceneTitle">使用场景</div>
      <div class="sceneConten">
        <div :class="sceneNum === 0 ? 'sceneBut':''" @click="getAll(0)">全部</div>
        <div v-for="(item, index) in sceneList" @click="getAll(item.id)" :key="index" :class="sceneNum === item.id ? 'sceneBut':''">{{item.name}}</div>
      </div>
    </div>
    <!--   所属分类-->
    <div class="filter-con">
      <div class="sceneTitle">所属分类</div>
      <div class="tag-con">
        <el-popover
          :key="tag.id"
          v-for="(tag, index) in tagList"
          placement="bottom"
          trigger="click"
          :ref="'popover-' + tag.id"
          @show="onPopoverShow(tag.id)"
          :disabled = 'tag.showCarse'
        >
          <div>
            <el-cascader-panel
              v-model="tag.select"
              @change="onCascaderChange(index)"
              :options="tag.children"
              :props="tagProps"
              popper-class="select_radio"
            ></el-cascader-panel>
          </div>
          <span slot="reference" :class="['tag', tag.select ? 'active' : '']">
                {{ (tag.select || "").toString() || tag.moduleName }}
                <i class="el-icon-arrow-down"></i>
              </span>
        </el-popover>
      </div>
    </div>
    <div class="filter-con" v-if="selectTags.length > 0" style="padding-top: 5px">
      <div class="title">已选：</div>
      <div class="tag-con">
      <span class="sel-tag" v-for="tag in selectTags" :key="tag">
        {{ tag }}
        <span @click="onSelectTagRemove(tag)" class="del"></span>
      </span>
      </div>
    </div>
    <div style="padding: 8px 24px;background-color: #fff">
      <el-table
        :data="dataList"
        style="border: 1px solid #eeeeee"
        :header-cell-style="{background:'#EBE9E9', color:'#000000', fontsize:'16px'}"
        :cell-style="{ color: 'rgba(0,0,0,0.85)', fontsize:'14px'}">
        <el-table-column label="标题" prop="fileName"></el-table-column>
        <el-table-column label="标签" min-width="200">
          <template slot-scope="scope">
                    <span
                      v-for="(item, index) in scope.row.tagList"
                      :key="index"
                    >{{scope.row.tagList.length-1!==index?item.tagsName+'，':item.tagsName}}</span
                    >
          </template>
        </el-table-column>
        <el-table-column label="所属模块" prop="moduleName" min-width="50"></el-table-column>
        <el-table-column label="创建时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatter }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <span style="cursor: pointer;color:#E60027 " @click="getDetails(scope.row.lxPreviewUrl)">查看详情</span>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-pagination
          @size-change="sizeChangeHandleHis"
          @current-change="currentChangeHandleHis"
          :current-page="pageNum"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;padding-bottom: 20px;margin: 25px 50px">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getSceneList, moduleList, dataList } from "@/api/queriesList";
import moment from "moment";

export default {
  name: "bid",
  props: {
    fileName: {
      type: String,
      default: () => null
    },
    tagName: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      carseNum: null,
      pageNum: 1,
      pageSize: 10,
      sceneNum: 0,
      total:0,
      sceneList: [],
      tagList: [],
      popoverId: null,
      tagProps: {
        value: "moduleName",
        label: "moduleName",
        children: "children",
        checkStrictly: true
      },
      dataList: [],
      selectList:[]
    }
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
  computed: {
    selectTags() {
      let result = [];

      let getTags = list => {
        list?.forEach(item => {
          if (item.select) {
            result.push(item.select.toString());
          }
          getTags(item.childrens);
        });
      };

      getTags(this.tagList);
      return result;
    },
    selectTagIds() {
      let result = [];
      let tagName = null
      this.tagList.forEach(item => {
        if(item.select) {
          tagName = [item.select[item.select.length-1]];
        }
      })
      let getTagIds = list => {
        list?.forEach(item => {
          let selectOne = item.children?.find(aa => aa.moduleName == tagName);
          if(!selectOne) {
            item.children?.forEach(obj => {
              let selectTag = obj.children?.find(oo => oo.moduleName == tagName);
              if (selectTag) {
                selectTag.childrenModuleIdList.forEach(val => {
                  result.push(val);
                })
              }else {
                getTagIds(obj.children)
              }
            });
          }else {
            selectOne.childrenModuleIdList.forEach(val => {
              result.push(val);
            })
          }
          getTagIds(item.children);
        });
      };
      getTagIds(this.tagList);
      return result;
    },
  },
  mounted() {
    this.getList()
    this.getModuleList(this.sceneNum)
  },
  methods: {
    getList() {
      getSceneList().then(res => {
        this.sceneList = res.data.data
        this.getModuleList(this.sceneNum)
      })
      this.pageNum = 1
      this.getmoduleList()
    },
    getModuleList(id) {
      let tagList = []
      this.selectList = []
      const params = {
        sid: id
      }
      moduleList(params).then(res => {
        if (res.code == 200) {
          let initModel = list => {
            (list.children || []).forEach(item => {
              item.select = null;
              initModel(item.children);
            });
          };
          res.data.forEach(val => {
            if(val.moduleName === '演示资料') {
              tagList = val.children;
            }
          })
          initModel(tagList);
          tagList.forEach(item => {
            item.showCarse = false
          })
          this.tagList = tagList;
          tagList.forEach(val => {
            if(val.childrenModuleIdList.length || val.childrenModuleIdList != null){
              val.childrenModuleIdList.forEach(str => {
                this.selectList.push(str)
              })
            }
          })
        }
      })
        .finally(_ => {
          this.getmoduleList();
        })
    },
    onPopoverShow(id) {
      this.popoverId = id;
    },
    onCascaderChange(e) {
      this.pageNum = 1
      this.tagList.forEach((item, index) => {
        if(index !== e){
          item.showCarse = true
          console.log(document.getElementsByClassName('tag'))
        }
      })
      this.$refs["popover-" + this.popoverId][0].doClose();
      this.getmoduleList()
    },
    onSelectTagRemove(tag) {
      let firstTage = tag.split(",")[0];
      this.tagList?.forEach(item => {
        let hasTag = item.children?.find(obj => obj.moduleName == firstTage);
        if (hasTag) {
          item.select = null;
        }
      });
      if(!this.selectTags.length) {
        this.tagList.forEach((item, index) => {
          item.showCarse = false
        })
      }
      this.getmoduleList();
    },
    getAll(id) {
      this.sceneNum = id
      this.getModuleList(id)
    },
    // 获取页面数据
    getmoduleList() {
      const data = {
        moduleIds: this.tagList.length ? (!this.selectTagIds.length && this.sceneNum != 0 ? this.selectList : this.selectTagIds) : ['-1'],
        fileName: this.fileName,
        tagName: this.tagName,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        isLazyLoad: true,
        startDateTime: '',
        endDateTime: '',
        value: '0',
        isDisabled: 0
      }
      dataList(data).then(res => {
        this.dataList = res.data.data
        this.total = res.data.total
      })
    },
    // 每页数
    sizeChangeHandleHis (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getmoduleList()
    },
    // 当前页
    currentChangeHandleHis (val) {
      this.pageNum = val
      this.getmoduleList()
    },
    // 查看详情
    getDetails(lxPreviewUrl){
      window.open(lxPreviewUrl)
    },
  },
}
</script>

<style scoped lang="less">
::v-deep .el-radio__inner {
  top: -18px;
  left: -19px;
  border-radius: 0;
  border: 0;
  width: 170px;
  height: 34px;
  background-color: transparent;
  cursor: pointer;
  box-sizing: border-box;
  position: absolute;
}
::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: transparent;
}
.sceneBut{
  background: #FFCCC7;
  color: #E60027 ;
  border-color: #FFCCC7 !important;
}
.filter-con {
  padding: 0.1rem 0.3rem;
  display: flex;
  align-items: center;
  & > .title {
    flex: 0 0 auto;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    font-weight: bold;
  }
  & > .sceneTitle{
    margin-top: 5px;
    width: 100px;
    line-height: 32px;
    font-size: 14px;
    font-family: Inter-Medium, Inter;
    font-weight: bold;
    color: rgba(0,0,0,0.85);
  }
  & > .tag-con {
    flex: 1;
    & .tag {
      display: inline-block;
      border-radius: 18px;
      border: 1px solid #c0c4cc;
      //margin: 0 0.04rem;
      line-height: 34px;
      min-width: 95px;
      padding: 0 7.5px;
      text-align: center;
      position: relative;
      cursor: pointer;
      font-size: 14px;
      margin-top: 8px;
      &.active {
        background-color: #ffccc7;
        color: #e60027;
        border-color: #ffccc7;
      }
    }
    & .sel-tag {
      padding: 0 0.12rem;
      background-color: #f5f5f5;
      color: rgba(0, 0, 0, 0.6);
      line-height: 0.28rem;
      height: 0.28rem;
      display: inline-block;
      font-size: 0.14rem;
      margin: 0 0.06rem;
      position: relative;
      & > .del {
        position: absolute;
        width: 0.16rem;
        height: 0.16rem;
        background: url("~@/assets/imgs/icon_gray_close@2x.png") no-repeat center center / 100% auto;
        top: -0.08rem;
        right: -0.04rem;
        cursor: pointer;
      }
    }
  }
}
.scene{
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  padding-left: 0.3rem;
  .sceneTitle{
    margin-top: 5px;
    width: 100px;
    line-height: 32px;
    font-size: 14px;
    font-family: Inter-Medium, Inter;
    font-weight: bold;
    color: rgba(0,0,0,0.85);
  }
}
.sceneConten{
  display: flex;
  flex-wrap: wrap;
  div{
    line-height: 34px;
    min-width: 90px;
    padding: 0 10px;
    border-radius: 18px;
    opacity: 1;
    border: 1px solid #c0c4cc;
    text-align: center;
    margin-right: 8px;
    cursor: pointer;
  }
}
</style>
